<ng-container *ngIf="viewModel$ | async as viewModel">
	<div class="user-permissions-page" *ngIf="viewModel.state === 'ready'">
		<div class="user-permissions-page__header">
			<div>
				<div class="user-permissions-page__eyebrow">User permissions</div>
				<div class="user-permissions-page__title">{{ viewModel.userDisplayName }}</div>
				<div class="user-permissions-page__subtitle">{{ viewModel.userSecondaryText }}</div>
			</div>

			<div class="user-permissions-page__actions">
				<dx-button text="Back" type="normal" icon="back" (onClick)="back()"></dx-button>
				<dx-button text="Refresh" type="default" icon="refresh" (onClick)="refresh()"></dx-button>
			</div>
		</div>

		<div class="user-permissions-page__summary">
			<div class="user-permissions-card">
				<div class="user-permissions-card__label">Assigned groups</div>
				<div class="user-permissions-card__value">{{ viewModel.groups.length }}</div>
			</div>
			<div class="user-permissions-card">
				<div class="user-permissions-card__label">Effective permissions</div>
				<div class="user-permissions-card__value">{{ viewModel.permissions.length }}</div>
			</div>
		</div>

		<div class="user-permissions-page__section">
			<div class="user-permissions-page__section-title">Assigned groups</div>
			<div class="user-permissions-page__tags" *ngIf="viewModel.groups.length > 0; else noGroups">
				<span class="user-permissions-page__tag" *ngFor="let group of viewModel.groups">{{ group }}</span>
			</div>
			<ng-template #noGroups>
				<div class="user-permissions-page__empty">This user is not attached to any groups.</div>
			</ng-template>
		</div>

		<div class="user-permissions-page__section">
			<div class="user-permissions-page__section-title">Permissions inherited from groups</div>
			<div class="user-permissions-page__empty" *ngIf="viewModel.permissions.length === 0">
				No effective permissions found from group assignments.
			</div>

			<dx-data-grid
				*ngIf="viewModel.permissions.length > 0"
				[dataSource]="viewModel.permissions"
				[showBorders]="true"
				[hoverStateEnabled]="true"
				[rowAlternationEnabled]="true"
				[width]="'100%'"
				[columnAutoWidth]="false"
				[wordWrapEnabled]="true"
				height="calc(100vh - 420px)">
				<dxo-sorting mode="multiple"></dxo-sorting>
				<dxo-filter-row [visible]="true"></dxo-filter-row>
				<dxo-search-panel [visible]="true"></dxo-search-panel>
				<dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
				<dxi-column dataField="category" caption="Group" [width]="170"></dxi-column>
				<dxi-column dataField="displayPermissionName" caption="Permission" [minWidth]="180"></dxi-column>
				<dxi-column dataField="permissionCode" caption="Code" [width]="250"></dxi-column>
				<dxi-column dataField="sourceGroups" caption="Assigned via groups" [minWidth]="220"></dxi-column>
				<dxi-column dataField="displayPermissionDescription" caption="Permission description" [minWidth]="220"></dxi-column>
				<dxi-column dataField="permissionKey" caption="ID" [visible]="false"></dxi-column>
			</dx-data-grid>
		</div>
	</div>

	<div class="user-permissions-page__loading" *ngIf="viewModel.state === 'loading'">
		Loading user permissions...
	</div>

	<div class="user-permissions-page__empty" *ngIf="viewModel.state === 'error'">
		Unable to load user permissions.
	</div>
</ng-container>
